import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { TextKeys } from '../../../core/i18n/text-keys';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MaterialFormSettingsModel } from '../../../core/models/material/material-form-settings.model';
import { MaterialModel } from '../../../core/models/material/material-model';
import { MaterialCatalogueItemsService } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.service';
import { InputWithSelectionListComponent } from '../../input-with-selection-list/input-with-selection-list.component';
import { MaterialCatalogueItemsQuery } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.query';
import { MaterialCatalogueListItem } from 'src/app/core/models/client-models';

@Component({
  selector: 'app-material-form',
  templateUrl: './material-form.component.html',
  styleUrls: ['./material-form.component.scss'],
})
export class MaterialFormComponent implements OnInit, AfterViewInit {
  @ViewChild('inputFieldWithSelection')
  inputFieldWithSelection: InputWithSelectionListComponent<MaterialCatalogueListItem>;
  @ViewChild('inputFieldWithSelectionDescription')
  inputFieldWithSelectionDescription: InputWithSelectionListComponent<MaterialCatalogueListItem>;

  @Input() displaySettings: MaterialFormSettingsModel;
  @Input() defaultValues: MaterialModel;

  materialForm: UntypedFormGroup;
  texts = TextKeys;

  listRoute = 'material-catalogue-selection';
  catalogueDisabled$ = new BehaviorSubject(false);
  catalogueVisible$ = new BehaviorSubject(true);

  private subscriptions = new Subscription();

  Total: string;

  constructor(
    public catalogueService: MaterialCatalogueItemsService,
    public materialCatalogueQuery: MaterialCatalogueItemsQuery,
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  get MaterialNumber() {
    return this.inputFieldWithSelection;
  }

  get Name() {
    return this.materialForm.get('Name');
  }

  get Description() {
    return this.materialForm.get('Description');
  }

  get Quantity() {
    return this.materialForm.get('Quantity');
  }

  get Unit() {
    return this.materialForm.get('Unit');
  }

  get Price() {
    return this.materialForm.get('Price');
  }

  get Note() {
    return this.materialForm.get('Note');
  }

  get Date() {
    return this.materialForm.get('Date');
  }

  ngOnInit() {
    this.createFrom();
  }

  ngAfterViewInit() {
    this.Date?.setValue(this.defaultValues?.date);
    this.MaterialNumber?.setValue(this.defaultValues?.number);
    this.Name?.setValue(this.defaultValues?.description);
    this.Description?.setValue(this.defaultValues?.description2);
    this.Quantity?.setValue(this.defaultValues?.quantity);
    this.Unit?.setValue(this.defaultValues?.unit);
    this.Price?.setValue(this.defaultValues?.price);
    this.Note?.setValue(this.defaultValues?.note);
    this.registerPriceChange();
    this.registerQuantityChange();
    this.setTotal();
  }

  registerPriceChange() {
    this.subscriptions.add(
      this.Price.valueChanges.subscribe(() => {
        this.setTotal();
      })
    );
  }

  registerQuantityChange() {
    this.subscriptions.add(
      this.Quantity.valueChanges.subscribe(() => {
        this.setTotal();
      })
    );
  }

  setValues(material: MaterialCatalogueListItem) {
    this.MaterialNumber.setValue(material?.number);
    this.Name.setValue(material?.name);
    this.Description.setValue(material?.description);
    this.Price.setValue(material?.price);
    this.Quantity.setValue(material?.quantity);
    this.Unit.setValue(material?.unit);
  }

  createFrom() {
    this.materialForm = this.fb.group({
      MaterialNumber: new UntypedFormControl('', {}),
      Name: new UntypedFormControl('', {
        validators: [Validators.required],
      }),
      Description: new UntypedFormControl('', {}),
      Quantity: new UntypedFormControl('', {
        validators: [Validators.required],
      }),
      Unit: new UntypedFormControl('', {}),
      Price: new UntypedFormControl('', {
        validators: [Validators.required],
      }),
      Note: new UntypedFormControl('', {}),
      Date: new UntypedFormControl('', {}),
    });
  }

  listClick() {
    this.router.navigate(['material-catalogue-selection'], {
      relativeTo: this.route,
    });
  }

  clearForm() {
    this.createFrom();
  }

  allRequiredFiled(): boolean {
    return (
      this.Quantity?.value >= 0 &&
      this.Price?.value >= 0 &&
      this.Name?.value &&
      this.Name?.value !== ''
    );
  }

  markAllTouched(): void {
    this.materialForm.markAllAsTouched();
  }

  private setTotal() {
    if (this.Price.value && this.Quantity.value) {
      const a = this.Price.value;
      const b = this.Quantity.value;
      this.Total = (a * b).toFixed(2);
    }
  }
}
